import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { type AppState } from './index';
import { type Middleware } from 'redux';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { addToast, cleanStore, endLoading, startLoading } from 'src/old/actions';
import { toastTypes } from 'src/shared/components/Toast/ToastOptions';
import i18n from 'i18next';

export const api = createApi({
  tagTypes: [
    'ExtraPayment',
    'Flexflow',
    'Employee',
    'Payroll',
    'Blacklist',
    'Subsidiary',
    'Liquidation',
    'Collective',
    'SocialBenefit',
    'ExternalConsumption'
  ],
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL as string}`,
    credentials: 'include',
    prepareHeaders: (headers, { getState, extra }) => {
      // @ts-expect-error todo typings for store
      const token = (getState() as AppState).session.user.token as string;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: () => ({})
});

export const superApi = createApi({
  tagTypes: ['ExtraPayment', 'Payment', 'Subsidiary'],
  reducerPath: 'superApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL as string}super`,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      return headers;
    }
  }),
  endpoints: () => ({})
});

export const commonApi = createApi({
  tagTypes: ['Territories'],
  reducerPath: 'commonApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_ZEUS_API_URL as string}/dashboard`,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      return headers;
    }
  }),
  endpoints: () => ({})
});

export const zeusSuperApi = createApi({
  tagTypes: ['Holdings', 'Companies', 'Contacts', 'ContactSettings', 'ExtraPayment', 'HoldingAlerts', 'Hub'],
  reducerPath: 'zeusSuperApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_ZEUS_API_URL as string}/dashboard/super`,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      return headers;
    }
  }),
  endpoints: () => ({})
});

export const zeusApiV1 = createApi({
  reducerPath: 'zeusApiV1',
  tagTypes: ['Payroll', 'integration', 'factorial', 'personio', 'buk', 'bizneo'],
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_ZEUS_API_URL as string}`,
    credentials: 'include',
    prepareHeaders: (headers, { getState, extra }) => {
      // @ts-expect-error todo typings for store
      const token = (getState() as AppState).session.user.token as string;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: () => ({})
});

export const zeusApi = createApi({
  reducerPath: 'zeusApi',
  tagTypes: ['Companies', 'Flexflow', 'SelfFunding', 'Limits', 'HoldingAlerts', 'UserHolding', 'Admin'],
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_ZEUS_API_URL as string}/dashboard`,
    credentials: 'include',
    prepareHeaders: (headers, { getState, extra }) => {
      // @ts-expect-error todo typings for store
      const token = (getState() as AppState).session.user.token as string;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: () => ({})
});

export const authMiddleware: Middleware = () => next => action => {
  const status = action?.payload?.originalStatus || action?.payload?.status;
  const noAutoLogout = action?.meta?.arg?.originalArgs?.noAutoLogout;

  if (isRejectedWithValue(action) && status === 401 && !noAutoLogout) {
    localStorage.clear();
    next(cleanStore());
    window.location.replace('/auth/login');
  }

  return next(action);
};

export const loaderMiddleware: Middleware = store => next => action => {
  if (action.type.endsWith('/pending')) {
    startLoading()(store.dispatch);
  } else if (action.type.endsWith('/fulfilled') || action.type.endsWith('/rejected')) {
    endLoading()(store.dispatch);
  }
  if (action.type.endsWith('/rejected') && !action?.meta?.arg.originalArgs?.isCustomError) {
    const message = action?.payload?.data?.error
      ? i18n.t(`error.${action.payload.data.error as string}`, { ns: 'toasts' })
      : undefined;

    store.dispatch(addToast({ ...toastTypes.error, defaultMessage: message }, action?.payload));
  }
  return next(action);
};
